import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BiLinkExternal } from "react-icons/bi";

function ResearchCard(props) {
    return (
        <Card className="project-card-view">
            <Card.Img variant="top" src={props.imgPath} alt="card-img" style={{ height: "33%" }} />
            <Card.Body style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                <div>
                    <Card.Title>{props.title}</Card.Title>
                    <Card.Text style={{ textAlign: "left" }}>
                        {props.description}
                    </Card.Text>
                </div>
                <div>
                <Button variant="primary" href={props.link} target="_blank" style={{ marginTop: "auto", width:"80%", textAlign:"center" }}>
                    <BiLinkExternal /> &nbsp;
                    {"View Research"}
                </Button>
                </div>
            </Card.Body>
        </Card>
    );
}

export default ResearchCard;
